import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { ApplicantsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetCreditRatingRequestedStatus = z.object({
    applicant1: ApplicantsTableDefinitionZod.shape.creditRatingRequestedStatus.nullable(),
    applicant2: ApplicantsTableDefinitionZod.shape.creditRatingRequestedStatus.nullable(),
    schufaLastPosition: z.number().nullable(),
});

export type SchemaLoanRequestResolver_GetCreditRatingRequestedStatus = z.infer<
    typeof schemaLoanRequestResolver_GetCreditRatingRequestedStatus
>;

export type LoanRequestResolver_GetCreditRatingRequestedStatus = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetCreditRatingRequestedStatus
>;
